// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3jJEk","rootSuccess":"CompleteLink_rootSuccess__1ZAre","rootFailure":"CompleteLink_rootFailure__3BDb8","isDisabled":"CompleteLink_isDisabled__A_vt1"};